/**
 * Classic I: greed (docs/spec/03 §2). A cave thick with diamonds, split by brick walls with
 * staggered gaps: a big quota, little time, and every gap a choice of route.
 */

import type { CaveDef } from '../types';

export const caveI: CaveDef = {
  id: 'I',
  name: 'GOLD RUSH',
  hint: 'Diamonds everywhere and no time to be choosy.',
  intermission: false,
  colors: [9, 14, 7],
  diamondValue: 20,
  extraValue: 30,
  fill: { base: '.', items: [['d', 9], ['r', 12], [' ', 3]] },
  levels: [
    { seed: 2201, diamonds: 35, time: 80, tick: 140 },
    { seed: 2202, diamonds: 40, time: 75, tick: 130 },
    { seed: 2203, diamonds: 45, time: 70, tick: 125 },
    { seed: 2204, diamonds: 50, time: 65, tick: 120 },
    { seed: 2205, diamonds: 55, time: 60, tick: 115 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W?????????w?????????w????????w?????????W',
    'W?????????w?????????w??????????????????W',
    'W????????????ddd????w??????????????????W',
    'W???????????????????w????????w????d.d??W',
    'W??dd.dd??w?????????w????????w?????????W',
    'W?????????w??????????????????w?????????W',
    'W?????????w??????????????????w?????????W',
    'W?????????w?????????w????????w?????????W',
    'W...??????w?????????w?d.d.d??w?????????W',
    'W.P.??????w?????????w????????????????X?W',
    'W...???????????dd???w??????????????????W',
    'W?????????w?????????w????????w?????????W',
    'W?????????w?????????w????????w?????????W',
    'W?????????w?????????w????????w???ddd???W',
    'W?????????w??????????????????w?????????W',
    'W???d.d???w??????????????????w?????????W',
    'W?????????w?????????w??????????????????W',
    'W?????????????dd????w????????w?????????W',
    'W???????????????????w???ddd??w?????????W',
    'W?????????w?????????w????????w?????????W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
